(function () {
  const overlay = document.querySelector('[data-af-overlay]');
  const mobileTrigger = document.querySelector('[data-af-mobile-trigger]');

  function getSidebar() { return document.getElementById('AF-sidebar'); }
  function getForm() { return document.getElementById('AF-form'); }
  function getProducts() { return document.querySelector('[data-af-products]'); }

  if (!getForm() || !getProducts()) return;

  document.addEventListener('click', function (e) {
    const toggle = e.target.closest('.AF-group__toggle');
    if (!toggle) return;
    const panel = toggle.nextElementSibling;
    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
    if (panel) panel.hidden = expanded;
  });

  function openDrawer() {
    const sidebar = getSidebar();
    if (sidebar) sidebar.classList.add('is-open');
    if (overlay) overlay.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    const sidebar = getSidebar();
    if (sidebar) sidebar.classList.remove('is-open');
    if (overlay) overlay.hidden = true;
    document.body.style.overflow = '';
  }
  if (mobileTrigger) mobileTrigger.addEventListener('click', openDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-af-mobile-close]')) {
      closeDrawer();
    }
  });

  function buildURL() {
    const form = getForm();
    const formData = new FormData(form);
    const params = new URLSearchParams();
    for (const [key, value] of formData.entries()) {
      if (value !== '') params.append(key, value);
    }
    return `${window.location.pathname}?${params.toString()}`;
  }

  /* ---- Price bands ------------------------------------------------------
     The Shopify price filter is a single gte/lte range, so only one band can
     be active at a time. The boxes look like checkboxes but behave as a
     single choice: picking one clears the others, clicking the active one
     again clears the price filter entirely. Band edges live in the snippet
     (snippets/gymkuma-filters.liquid) as data-gte / data-lte in JOD.
  ------------------------------------------------------------------------ */
  function getPriceInputs() {
    const form = getForm();
    if (!form) return { gte: null, lte: null };
    return {
      gte: form.querySelector('[data-af-price-gte]'),
      lte: form.querySelector('[data-af-price-lte]')
    };
  }

  function syncPriceBands() {
    const params = new URLSearchParams(window.location.search);
    let gte = '';
    let lte = '';
    params.forEach(function (value, key) {
      if (key.indexOf('.price.gte') !== -1) gte = value;
      if (key.indexOf('.price.lte') !== -1) lte = value;
    });
    const anyPrice = gte !== '' || lte !== '';
    document.querySelectorAll('[data-af-price-band]').forEach(function (band) {
      const bGte = band.getAttribute('data-gte') || '';
      const bLte = band.getAttribute('data-lte') || '';
      band.checked = anyPrice && bGte === gte && bLte === lte;
    });
  }

  document.addEventListener('change', function (e) {
    const band = e.target.closest('[data-af-price-band]');
    if (!band) return;
    const list = band.closest('[data-af-price-bands]');
    if (list && band.checked) {
      list.querySelectorAll('[data-af-price-band]').forEach(function (other) {
        if (other !== band) other.checked = false;
      });
    }
    const inputs = getPriceInputs();
    if (inputs.gte) inputs.gte.value = band.checked ? (band.getAttribute('data-gte') || '') : '';
    if (inputs.lte) inputs.lte.value = band.checked ? (band.getAttribute('data-lte') || '') : '';
    applyFilters();
  });

  function fetchAndSwap(url) {
    const productsEl = getProducts();
    productsEl.classList.add('is-loading');

    const fetchUrl = `${url}${url.includes('?') ? '&' : '?'}view=ajax`;

    fetch(fetchUrl)
      .then((res) => res.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const newProducts = doc.querySelector('[data-af-products]');
        const freshProductsEl = getProducts(); // re-fetch in case DOM shifted
        if (newProducts && freshProductsEl) freshProductsEl.innerHTML = newProducts.innerHTML;

        const newSidebar = doc.querySelector('#AF-sidebar');
        const freshSidebar = getSidebar();
        if (newSidebar && freshSidebar) freshSidebar.innerHTML = newSidebar.innerHTML;

        const newCount = doc.querySelector('.AF-mobile-bar__count');
        const freshCount = document.querySelector('.AF-mobile-bar__count');
        if (newCount && freshCount) freshCount.textContent = newCount.textContent;

        window.history.pushState({}, '', url);
        syncPriceBands();
        const productsAfter = getProducts();
        if (productsAfter) {
          productsAfter.classList.remove('is-loading');
          window.scrollTo({ top: productsAfter.offsetTop - 100, behavior: 'smooth' });
        }
        // closeDrawer();
      })
      .catch(function (err) {
        const p = getProducts();
        if (p) p.classList.remove('is-loading');
        console.error('Filter fetch failed:', err);
      });
  }

  function applyFilters() {
    fetchAndSwap(buildURL());
  }

  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-af-input]') && !e.target.matches('[data-af-price]')) {
      applyFilters();
    }
  });

  document.addEventListener('click', function (e) {
    if (e.target.matches('[data-af-apply-price]')) applyFilters();
  });

  document.addEventListener('click', function (e) {
    const sortBtn = e.target.closest('[data-af-sort]');
    if (!sortBtn) return;
    const form = getForm();
    let sortInput = form.querySelector('[data-af-sort-input]');
    if (!sortInput) {
      sortInput = document.createElement('input');
      sortInput.type = 'hidden';
      sortInput.name = 'sort_by';
      sortInput.setAttribute('data-af-sort-input', '');
      form.appendChild(sortInput);
    }
    sortInput.value = sortBtn.dataset.value;
    applyFilters();
  });

  document.addEventListener('click', function (e) {
    const clearLink = e.target.closest('[data-af-clear-all]');
    if (!clearLink) return;
    e.preventDefault();
    fetchAndSwap(clearLink.href || window.location.pathname);
  });

  window.addEventListener('popstate', function () {
    window.location.reload();
  });

  syncPriceBands();
})();
